import React, {useEffect, useRef, useState} from 'react';
import {GoogleLogin} from '@react-oauth/google';
import {getUserData} from '../../utils/userUtils';
import {sessionRequest} from './momentsSessionClient';

export default function PrivateSession({identity}) {
 const [session,setSession]=useState(null), [challenge,setChallenge]=useState(null), [message,setMessage]=useState(''), [available,setAvailable]=useState(false);
 const generation=useRef(0);
 const user=getUserData();
 const impersonating=!!user.isImpersonating;
 useEffect(()=>{
  let active=true; const gen=++generation.current;
  setSession(null);setChallenge(null);setMessage('');setAvailable(false);
  const clear=()=>{generation.current++;setSession(null);setChallenge(null);setMessage('Verify your identity again to continue.');};
  const storage=e=>{if(e.key==='wow_agent_user_data'||e.key==='momentsSessionReset') clear();};
  window.addEventListener('userLogout',clear);window.addEventListener('userImpersonation',clear);window.addEventListener('storage',storage);
  if(!impersonating) sessionRequest('status',{userId:identity.userId}).then(({data})=>{if(active&&gen===generation.current){setSession(data);setAvailable(true);}}).catch(e=>{if(active&&gen===generation.current&&e.response?.status!==503)setAvailable(true);});
  return ()=>{active=false;generation.current++;window.removeEventListener('userLogout',clear);window.removeEventListener('userImpersonation',clear);window.removeEventListener('storage',storage);};
 },[identity.userId,identity.accountId,impersonating]);
 useEffect(()=>{if(!session)return;const timer=setTimeout(()=>{generation.current++;setSession(null);setChallenge(null);setMessage('Verification expired. Your draft is unchanged.');},Math.max(0,new Date(session.expiresAt)-Date.now()));return()=>clearTimeout(timer);},[session]);
 if(impersonating||!available)return null;
 const start=async()=>{
  const gen=++generation.current;setMessage('');setChallenge(null);
  localStorage.setItem('momentsSessionReset',String(Date.now()));
  try {const {data}=await sessionRequest('challenge');if(gen!==generation.current)return;
   if(data.clientId!==process.env.REACT_APP_GOOGLE_CLIENT_ID){setMessage('Google verification configuration needs attention.');return;}
   setSession(null);setChallenge(data);
  }catch{if(gen===generation.current)setMessage('Could not start verification. Your draft is unchanged.');}
 };
 const exchange=async response=>{
  const gen=generation.current;
  try{const {data}=await sessionRequest('exchange',{credential:response.credential,userId:identity.userId},challenge.csrf);
   if(gen!==generation.current)return;setSession(data);setChallenge(null);setMessage('Identity verified. Conversation history is not enabled yet.');
  }catch{if(gen===generation.current){setChallenge(null);setMessage('Verification failed. Start again; your draft is unchanged.');}}
 };
 return <section aria-label="Private conversation verification">
  <p>{session?'Identity verified for this session.':'Verify your identity for private conversation features.'} Conversation history is not saved in this release.</p>
  {!session&&!challenge&&<button onClick={start}>Verify identity</button>}
  {challenge&&<GoogleLogin key={challenge.nonce} nonce={challenge.nonce} onSuccess={exchange} onError={()=>{setChallenge(null);setMessage('Verification failed. Try again.');}}/>}
  {message&&<p role="status">{message}</p>}
 </section>;
}
